import { httpRequest } from "../../http";
import { PopulationSegment } from "@models/populationSegment.model";

export class CommandGetPopulationSegments {
    async run(organizationId: number, limit: number, offset: number): Promise<PopulationSegment[]> {

        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/segments/`;

        const params = new URLSearchParams(
            {
                organization: String(organizationId),
                limit: String(limit),
                offset: String(offset)
            });

        const url = `${base}?${params.toString()}`;

        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return PopulationSegment.fromJsonList(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}
